import { FrameTimerEventEmitter, FrameTimerEvents, CreateFrameTimer } from "../../../Utils/FrameTimer";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { StageController } from "../../../Components/StageController";
import { FrameTimerPool } from "../../../Utils/FrameTimerPool";
import { TweenMax } from "gsap";
import { PageVisibilityHandler } from "../../../CustomComponents/PageVisibilityHandler";
import { Platforms } from "neo-games";
import { DataManager } from "../../../Managers/DataManager";

export class QuickspinDialog {
    private static _opened: boolean = false;
    private static _wasOpened: boolean = false;
    private static _container: HTMLElement;

    static openDialog(): void {
        QuickspinDialog.initializeDialog();

        if (!QuickspinDialog._opened && !QuickspinDialog._wasOpened) {
            if (QuickspinDialog._container != null && QuickspinDialog._container.classList.contains("_disabled")) {
                QuickspinDialog._container.classList.remove("_disabled");
            }

            PIXI.sound.pauseAll();
            StageController.pauseAnimations();
            FrameTimerPool.pause();
            TweenMax.pauseAll();

            PageVisibilityHandler.Enabled = false;
            QuickspinDialog._opened = true;
            QuickspinDialog._wasOpened = true;

            Platforms.Platforms.dialogOpened("quickspin", true);
        }
    }

    static closeDialog(): void {
        if (QuickspinDialog._opened) {
            QuickspinDialog.initializeDialog();
            if (QuickspinDialog._container != null && !QuickspinDialog._container.classList.contains("_disabled")) {
                QuickspinDialog._container.classList.add("_disabled");
            }

            PIXI.sound.resumeAll();
            StageController.resumeAnimations();
            FrameTimerPool.unpause();
            TweenMax.resumeAll();

            PageVisibilityHandler.Enabled = true;
            QuickspinDialog._opened = false;

            Platforms.Platforms.quickSpinDialog(DataManager.quickspinEnabled());
            Platforms.Platforms.dialogOpened("quickspin", false);
        }
    }

    private static initializeDialog(): void {
        if (QuickspinDialog._container == null) {
            QuickspinDialog._container = document.getElementById("quickspinDialog");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/QuickspinDialog.ts
 **/